var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("short-link-view", { attrs: { "target-page": "tv" } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }